module.exports = __webpack_public_path__ + "img/12_53.223f9e18.png";